import {useDictionary, useClient} from '@adamlip/okeoke.client';
import {useState, useContext} from 'react';
import {UserContext} from 'contexts/UserContext';
import useStorage from 'hooks/useStorage';
import {validatePin} from 'utils/User-v2';
import {toast} from 'react-hot-toast';
import {InputOtp} from '@heroui/react';

export default function PinHandler({email, onSuccess}) {
	const {getValue} = useDictionary();
	const {setSV, removeSV} = useStorage();
	const {setToken} = useClient();
	const {setUserLoggedIn} = useContext(UserContext);

	const [pinInputStatus, setPinInputStatus] = useState(false);
	const [pin, setPin] = useState('');
	const resetPinStatus = () => {
		setPinInputStatus(false);
	};

	const handlePinCheck = (pinCode) => {
		validatePin(email, pinCode, pinCallback);
	};

	const pinCallback = (e) => {
		if (e.success) {
			removeSV('anoLoginUUID');
			setSV('apiToken', e.data.token);
			setSV('apiTokenExpires', e.data.expires);
			setSV('realUser', true);

			setToken(e.data.token);

			setPinInputStatus('success');
			setUserLoggedIn(true);

			let dataToSendToWebView = {
				type: 'userUUID',
				data: e.data.uuid,
			};
			let emailDataToSendToWebView = {
				type: 'email',
				data: e.data.email,
			};
			window.ReactNativeWebView?.postMessage(JSON.stringify(emailDataToSendToWebView));
			window.ReactNativeWebView?.postMessage(JSON.stringify(dataToSendToWebView));

			setTimeout(() => {
        window.location.reload();
      }, 300);
			//onSuccess();
		} else {
			setPinInputStatus('failed');
			toast.error(getValue('app_v2_toast_loginInvalid'));
			setPin('');
		}
	};

	return (
		<div className='w-full shrink-0 flex items-center justify-center'>
			<InputOtp variant='bordered' autoFocus length={4} size='lg' onComplete={handlePinCheck} value={pin} onValueChange={(value) => setPin(value)} />
		</div>
	);
}
